import { isSupportedCurrency } from './currency.js';
import { ok, err } from '../contracts/result.js';
import { createAppError } from '../contracts/errors.js';
export function createMoney(amountMinor, currency) {
    if (!isSupportedCurrency(currency)) {
        return err(createAppError('INVALID_CURRENCY', `Unsupported currency code: ${String(currency)}`, false));
    }
    if (amountMinor < 0n) {
        return err(createAppError('INVALID_MONEY_AMOUNT', 'Monetary amountMinor cannot be negative', false));
    }
    return ok({ amountMinor, currency });
}
export function serializeMoney(money) {
    return {
        amountMinor: money.amountMinor.toString(),
        currency: money.currency,
    };
}
export function deserializeMoney(raw) {
    if (typeof raw !== 'object' || raw === null) {
        return err(createAppError('INVALID_JSON', 'Input must be a non-null object', false));
    }
    const candidate = raw;
    if (typeof candidate.amountMinor !== 'string' || typeof candidate.currency !== 'string') {
        return err(createAppError('INVALID_MONEY_JSON', 'MoneyJSON must contain string amountMinor and string currency', false));
    }
    if (!isSupportedCurrency(candidate.currency)) {
        return err(createAppError('INVALID_CURRENCY', `Unsupported currency code: ${candidate.currency}`, false));
    }
    try {
        const amountMinor = BigInt(candidate.amountMinor);
        return createMoney(amountMinor, candidate.currency);
    }
    catch (_error) {
        return err(createAppError('INVALID_BIGINT_STRING', `Cannot parse amountMinor string '${candidate.amountMinor}' to BigInt`, false));
    }
}
export function parseDecimalToMinorUnits(input) {
    const trimmed = input.trim();
    if (!/^[0-9]+(\.[0-9]{1,2})?$/.test(trimmed))
        return null;
    const parts = trimmed.split('.');
    let integerPart = parts[0] ? parts[0].replace(/^0+/, '') : '';
    const decimalPart = (parts[1] || '').padEnd(2, '0');
    if (!integerPart) {
        integerPart = '0';
    }
    const combined = integerPart === '0' ? decimalPart.replace(/^0+/, '') : integerPart + decimalPart;
    if (combined === '' || combined === '0')
        return null;
    return combined;
}
export function formatMinorUnitsToMajor(amountMinorStr, currency) {
    const trimmedCurrency = currency ? currency.trim() : '';
    const suffix = trimmedCurrency ? ` ${trimmedCurrency}` : '';
    if (!/^[0-9]+$/.test(amountMinorStr)) {
        return `—${suffix}`;
    }
    const padded = amountMinorStr.padStart(3, '0');
    const majorPart = padded.slice(0, -2);
    const minorPart = padded.slice(-2);
    return `${majorPart}.${minorPart}${suffix}`;
}
